var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAshely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7912 10.1402C23.7912 15.7433 19.2806 20.2805 13.7105 20.2805C10.4815 20.2805 7.59555 18.7478 5.75903 16.3726C5.98103 16.3929 6.21312 16.4132 6.4452 16.4132C7.79736 16.4132 9.0587 15.9767 10.0779 15.2358C11.097 15.9767 12.3584 16.4132 13.7105 16.4132C17.1515 16.4132 19.9365 13.6117 19.9365 10.1402C19.9365 6.66881 17.1515 3.87745 13.7105 3.87745C12.3584 3.87745 11.097 4.31392 10.0779 5.0549C9.0587 4.31392 7.79736 3.87745 6.4452 3.87745C6.21312 3.87745 5.99112 3.8876 5.76912 3.91805C7.60564 1.53271 10.4815 0 13.7105 0C19.2806 0 23.7912 4.53723 23.7912 10.1402Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6709 10.1401C12.6709 12.2412 11.6517 14.0987 10.0775 15.2356C8.50338 14.0987 7.47412 12.2412 7.47412 10.1401C7.47412 8.03892 8.50338 6.1814 10.0775 5.04456C11.6517 6.1814 12.6709 8.03892 12.6709 10.1401Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6295 10.1402C3.6295 12.4849 4.42667 14.647 5.75864 16.3725C2.64061 16.0274 0.20874 13.368 0.20874 10.1402C0.20874 6.91235 2.64061 4.25295 5.75864 3.90784C4.42667 5.62325 3.6295 7.79544 3.6295 10.1402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAshely);
export default __webpack_public_path__ + "static/media/logo-ashely.7e63727394597ceb43f9b56df51d739b.svg";
export { ForwardRef as ReactComponent };